module.exports = __webpack_public_path__ + "static/media/catalogoNegative.e8db1406.png";